/**
 * <s-shuffle> — Shows a random selection of list items on each page load.
 *
 * Liquid renders a pool of candidate items; anything past the visible count
 * starts out with the `hidden` attribute so the row looks right without
 * JavaScript. On mount, the items are shuffled, the first N are shown and the
 * rest stay hidden.
 *
 * Element dataset:
 *   data-count — How many items to show (defaults to 5).
 *
 * Required child markup:
 *   [data-shuffle-list]  — The list whose direct children get shuffled.
 */
class SShuffle extends HTMLElement {
  connectedCallback() {
    const list = this.querySelector('[data-shuffle-list]');
    if (!list) return;

    const count = Number.parseInt(this.dataset.count ?? '5', 10) || 5;
    const items = Array.from(list.children);

    for (let i = items.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      [items[i], items[j]] = [items[j], items[i]];
    }

    items.forEach((item, index) => {
      item.hidden = index >= count;
      list.append(item);
    });
  }
}

if (!customElements.get('s-shuffle')) {
  customElements.define('s-shuffle', SShuffle);
}
